import { type ClassValue, clsx } from 'clsx'
import { UseFormReset } from 'react-hook-form'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max)
}
export function resetForm<T extends Record<string, any>>(
  reset: UseFormReset<T>
) {
  reset((formData) => {
    Object.keys(formData).forEach((key) => {
      if (Array.isArray(formData[key])) {
        formData[key as keyof T] = [] as T[keyof T]
      } else if (formData[key] instanceof Date) {
        formData[key as keyof T] = null as T[keyof T]
      } else {
        formData[key as keyof T] = '' as T[keyof T]
      }
    })
    return { ...formData }
  })
}

export const isEqual = (obj1?: any, obj2?: any) => {
  if (!obj1 && obj2) {
    return false
  }
  if (!obj2 && obj1) {
    return false
  }
  if (!obj1 && !obj2) {
    return true
  }

  const keys1 = Object.keys(obj1 ?? {})
  const keys2 = Object.keys(obj2 ?? {})
  if (keys1.length !== keys2.length) {
    return false
  }
  for (const key of keys1) {
    if (obj1![key] !== obj2![key]) {
      return false
    }
  }
  return true
}
